import { defineStore } from 'pinia'

export const Loading = defineStore('Loading', {
    state: () => ({
        isLoading: false,
        title: 'Yükleniyor...',
        description: 'Lütfen bekle...'
    }),

    actions: {
        setTitle(title) {
            this.title = title;
            return this;
        },
        
        setDescription(description) {
            this.description = description;
            return this;
        },
        
        show() {
            this.isLoading = true;
        },
        
        hide() {
            this.isLoading = false;
            this.title = null;
            this.description = null;
            this.$reset();
        }
    }
});
